import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEn from '../locales/en/translation.json';

export const resources = {
  en: {
    translation: translationEn,
  },
} as const;

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  debug: true,
  interpolation: {
    escapeValue: false,
  },
  resources,
});
